import React from 'react';
import ServiceCategoryPage from './ServiceCategoryPage';

const GeneralReferrals = () => {
  return (
    <ServiceCategoryPage
      category="General Referrals"
      title="General Referrals"
      intro="Need a referral to a specialist, a private prescription, or a request for a blood test or scan? Our UK doctors can provide same-day referral letters."
    />
  );
};

export default GeneralReferrals;